import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');
import { SafeResourceUrl } from '@angular/platform-browser';
import { GetDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import heic2any from "heic2any";

@Component({
  selector: 'app-fileManager-viewer',
  templateUrl: './fileManager-viewer.component.html',
  styleUrls: ['./fileManager-viewer.component.scss']
})
export class FileManagerViewerComponent implements OnInit {

  organizationId: any;
  databaseId: any;
  userID: any;
  myOfficeID: any;
  responseHolder: any;
  myFormGroup: FormGroup; 
  documentId:number;
  DocumentShow:boolean;
  folderID :number=0;
  docData :any;
  documentType: any;
  fileSize: string="";
  documentName: string="";
  createdOn:any;
  documentpath: SafeResourceUrl;
  modulename: string="";
  documentdetails= new GetDocumentDetails();
  documentID :number=0;
  viewer = 'google';
  selectedImagetoShow: any;
  documentModel = {
    userID: '',
    documentID:0,  
    databaseID: 0,
    organizationID: 0,
    type:0
  };
  uploadedBy:string="";
  showDetail:boolean = false;
  spinner:boolean=false;
  token:any="";
  params:string="";
  decryptedToken: any;
  fileManagerItemID:number=0;

  constructor(private dialog: MatDialog,private router:Router,private route: ActivatedRoute,
    private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef,private statusConstant: StatusConstant,
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses,
    private formBuilder: FormBuilder, private formsService:FormsService){
    } 

    ngOnInit(): void {
      
      this.getQueryParameter();  

     
    }

    getQueryParameter() {
      this.route.queryParams.subscribe(params => {
        this.token = params['token'];
        
        this.params=  decodeURIComponent(this.token);
        const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
        this.decryptedToken = JSON.parse(decryptedTokenString);       
        this.fileManagerItemID=this.decryptedToken.FileID;
        this.organizationId = this.decryptedToken.OrganizationID;
        this.databaseId = 1;      
        this.myOfficeID = this.decryptedToken.OfficeID;         
      //  this.documentID = this.docData[0].documentID;
                  
        //this.createForm(); 
       // this.DocumentShow=false;
       // this.folderID;
        //this.docData;    
       // this.documentName="";
        this.documentType="";
        //this.fileSize="";
       // this.createdOn="";
        this.documentpath="";
        this.modulename = "FileManager";
      //  this.documentdetails = new GetDocumentDetails();     
        this.getDocumentDetails(this.fileManagerItemID); 
    });     
    }


    b64toBlob(b64Data, contentType='', sliceSize=512){
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
    
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
    
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
    
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
    
      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }


     blobToBase64 = blob => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise(resolve => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    };


    getHEICFile(fileName:any,url:any) {
      this.formsService.getAttachment(fileName,url).subscribe((response) => {
        if (response !== undefined) {
          const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
          let blobfile=this.b64toBlob(response.data.base64URL,response.data.contentType);
         (heic2any({
              blob:blobfile,
              toType:"image/jpeg",
              quality: 0.5
            })).then((conversionResult) => {
                this.blobToBase64(conversionResult).then(res => {     
                  this.spinner=false;         
                 // this.loaderService.hide();
                  this.selectedImagetoShow=res;
                });
              });
        }else{
          this.toastr.error('File download failed.', '', {
            timeOut: 3000,
          });
        }
      });
    }



    getDocumentDetails(fileManagerItemID) {
      this.spinner=true;
     // this.loaderService.show();
      this.documentpath="";     
      this.documentModel.userID = "e40cf57c-792e-4867-ac9e-848010990031";//this.currentUser.UID;
      this.documentModel.documentID = fileManagerItemID,//result[0].documentID;
      this.documentModel.databaseID = Number(this.databaseId);
      this.documentModel.organizationID = Number(this.organizationId);
      this.documentModel.type =1; // 1 FOR OCRE, 2 FOR CONTACT, 3 COMPANY     
      
       let reqModel = {
        fileManagerItemID:fileManagerItemID,//this.documentID,
        userID: "e40cf57c-792e-4867-ac9e-848010990031",//this.currentUser.UID,
        organizationID:Number(this.organizationId),
        databaseID:Number(this.databaseId),
        officeID:this.myOfficeID,
      }    
      this.formsService.GetFileManagerFileDetail(reqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
             // this.documentdetails = response.data;           
              this.documentId =  response.data.fileManagerItemID;           
              if(response.data.fileType!=undefined){
                this.documentType = response.data.fileType;
              }
              if(response.data.fileType==undefined){
                this.documentType = response.data.name.split('.').pop();
              }
              // if(response.data.fileSize!=null || response.data.fileSize!=undefined){
              //   this.fileSize = this.getReadableFileSizeString(response.data.fileSize);
              //   if(this.fileSize==undefined){
              //     this.fileSize =this.documentdetails.fileSize;
              //   }
              //   if(this.fileSize=="NaN kB" || this.fileSize=="NaN KB"){
              //     this.fileSize =this.documentdetails.fileSize;
              //   }
              // }
             
             // this.documentName =response.data.name;
             // this.createdOn =result.createdOn;
              // if(this.createdOn==undefined){
              //   this.createdOn =this.documentdetails.createdOn;
              // }
             // var path = response.data.azureblobPath;
              // var path2 = path.replace(/\\/g, "/");
              if(response.data.azureblobPath.indexOf("https://")>=0){
                this.documentpath = response.data.azureblobPath;
              }
              if(this.documentType!='' && this.documentType!=undefined){
                this.documentType=this.documentType.toLowerCase();
              }
              if(this.documentType=='heic'){
                this.getHEICFile(this.documentName,this.documentpath);
                return;
               } else{
                 // this.spinner=false;
                 // this.loaderService.hide();
               }
          
              // if(response.data.uploadedByEmail==null){
              //   var firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,response.data.uploadByFirstName);
              //   var lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,response.data.uploadByLastName);
              //   this.uploadedBy =firstName+" "+lastName;
              // }
              // if(response.data.uploadedByEmail!=null){
              //   this.uploadedBy =response.data.uploadedByEmail;
              // }   
              this.spinner=false;                                                   
            }else{
              this.spinner=false;
            }
          } else {
            this.spinner=false;
          }
        });
    }
  
      
    // createForm() {
    //   this.myFormGroup = this.formBuilder.group({
    //     description: ['',]     
    //   });
    // }   
  
  
    // getReadableFileSizeString(fileSizeInBytes) {
    //   var i = -1;
    //   var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    //   do {
    //       fileSizeInBytes = fileSizeInBytes / 1024;
    //       i++;
    //   } while (fileSizeInBytes > 1024);
  
    //   return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
    // };
   
    
      
    // opendocdetail() {
    //   this.showDetail = !this.showDetail
    // }     
       
    // close() {   
    //   this.dialog.closeAll();
    // } 
    
    DownloadFile() {
      this.spinner=true;
      //this.loaderService.show();
      var ReqModel = {
        //transactionID: Number(sessionStorage.getItem("transactionID")),
        fileManagerItemID: this.fileManagerItemID,
        userID: "e40cf57c-792e-4867-ac9e-848010990031",//this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId)
      }
      this.formsService.DownloadDocument(ReqModel).subscribe((response) => {
        if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
          const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
          FileSaver.saveAs(data, response.name);
          this.spinner=false;
         // this.loaderService.hide();
        } else {
          this.toastr.error('File download failed.', '', {
            timeOut: 3000,
          });
          this.spinner=false;
          //this.loaderService.hide();
        }
      });
    }
  
  }
  